<div class="row">
  <div class="col-1">
    <app-back-button></app-back-button>
  </div>
  <div class="col">
    <h2 class="h2-responsive text-center">New Question</h2>
  </div>
</div>
<div class="row">
  <div class="col">
    <div class="card card-cascade narrower">
      <div class="view gradient-card-header primary-gradient white-text">
          <h3 class='h3-responsive text-center text-truncate'>{{question.prompt || "Untitled"}}</h3>
      </div>
      <div class="card-body">
        <form>
          <div class="form-group"> 
              <label for="prompt">Type:</label>
              <select class="form-control browser-default" id="display_type" name="display_type" name="display_type" 
                [(ngModel)]="question.type" (change)="updateType($event)">
                <option *ngFor="let type of DisplayTypes; let first=first;" [value]="type.value" [selected]="type.isSelected">{{type.name}}</option>
              </select>
            </div>
          <div class="form-group">
              <label for="prompt">Prompt:</label>
              <input class="form-control" type="text" id="prompt" name="prompt" [(ngModel)]="question.prompt" />
            </div>
          <!--<div class="form-group">
                <label for="displayOrder">Display Order:</label>
            <input class="form-control" type="number" id="displayOrder" name="displayOrder" [(ngModel)]="ctrl.question.display_order" />
          </div>-->
          <div class="form-group">
            <input class="form-control" [checked]="question.skip_scoring" 
              type="checkbox" id="skipScoring" name="skipScoring" [(ngModel)]="question.skip_scoring" />
            <label for="skipScoring">Do not score:</label>
          </div>
          <div class="form-group">
            <input class="form-control" [checked]="question.is_reversed" 
              type="checkbox" id="isReversed" name="isReversed" [(ngModel)]="question.is_reversed" />
            <label for="isReversed">Is Reversed:</label>
          </div>
          <div class="form-group">
            <label for="scale">Scale</label>
            <select class="form-control browser-default" id="scale" name="scale" *ngIf="scales?.length > 1"
              [(ngModel)]="question.assessment_scale">
              <option *ngFor="let scale of scales" [ngValue] = "scale">{{scale.name}}</option>
            </select>
            <input class="form-control" readonly *ngIf="scales?.length == 1" [value]="scales[0].name">
          </div>
          </form> 
          <input type="button" [disabled]="isSaving" (click)="save()" class="btn btn-primary" value="Save" />
          <input type="button" [disabled]="isSaving" (click)="saveAndCreateNew()" class="btn btn-primary" value="Save and Create New" />
          <!--<pre>
            {{ctrl.question|json}}
          </pre>-->
      </div>
    </div>
  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/admin/question-new/question-new.component.html